import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import SEO from "@/components/SEO";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-surface flex flex-col items-center justify-center px-6 py-16">
      <SEO title="Acceso CRM · Club Amistad" description="Acceso administrativo Club Amistad" path="/admin/login" noindex />

      <Link to="/" className="mb-10 group" aria-label="Club Amistad — Inicio">
        <img
          src="/club-amistad-logo.png"
          alt="Club Amistad"
          className="h-20 w-auto group-hover:scale-105 transition-transform"
        />
      </Link>

      <div className="card-soft w-full max-w-md p-8 md:p-10">
        <div className="text-center mb-8">
          <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-primary/10 text-brand-primary mb-4">
            <Lock className="h-5 w-5" />
          </div>
          <h1 className="font-outfit text-2xl font-semibold text-brand-primary">Mini-CRM</h1>
          <p className="text-sm text-brand-muted mt-2">Acceso administrativo</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="field-label" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field-input"
              data-testid="admin-email"
              placeholder="admin@clubamistad.com"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="field-label" htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-input"
              data-testid="admin-password"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-primary w-full disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {loading ? "Accediendo…" : "Entrar"}
          </button>
        </form>

        <p className="text-xs text-center text-brand-muted mt-8">
          Acceso restringido. Si has llegado aquí por error, <Link to="/" className="underline">vuelve al inicio</Link>.
        </p>
      </div>
    </div>
  );
}
